import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import CommunicationsNavigationIcon from 'Icons/NavigationItem/Communications';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';

const LazyCommunicationSettingsPage = React.lazy(() => import('./Pages'));

const companyConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.communication.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.communication.title',
            url: '/communication-settings',
            Icon: CommunicationsNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyCommunicationSettingsPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default companyConfiguration;
